"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SecurityToken_1 = require("../SecurityToken");

var Factory_1 = require("./Factory");

var PolymathError_1 = require("../../PolymathError");

var types_1 = require("../../types");

var utils_1 = require("../../utils");
/**
 * @hidden
 * Generates Security Token entities
 */


var SecurityTokenFactory =
/*#__PURE__*/
function (_Factory_1$Factory) {
  _inherits(SecurityTokenFactory, _Factory_1$Factory);

  // eslint-disable-next-line require-jsdoc
  function SecurityTokenFactory(context) {
    var _this;

    _classCallCheck(this, SecurityTokenFactory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SecurityTokenFactory).call(this, SecurityToken_1.SecurityToken, context));

    _this.generateProperties = function (uid) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _SecurityToken_1$Secu, symbol, contractWrappers, securityToken, _ref, _ref2, name, owner, address, tokenDetails, versionArray, granularity, totalSupply, treasuryWallet, currentCheckpoint;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _SecurityToken_1$Secu = SecurityToken_1.SecurityToken.unserialize(uid), symbol = _SecurityToken_1$Secu.symbol;
                contractWrappers = this.context.contractWrappers;
                _context.prev = 2;
                _context.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context.next = 13;
                return Promise.all([securityToken.name(), securityToken.owner(), securityToken.address(), securityToken.tokenDetails(), securityToken.getVersion(), securityToken.granularity(), securityToken.totalSupply(), securityToken.getTreasuryWallet(), securityToken.currentCheckpointId()]);

              case 13:
                _ref = _context.sent;
                _ref2 = _slicedToArray(_ref, 9);
                name = _ref2[0];
                owner = _ref2[1];
                address = _ref2[2];
                tokenDetails = _ref2[3];
                versionArray = _ref2[4];
                granularity = _ref2[5];
                totalSupply = _ref2[6];
                treasuryWallet = _ref2[7];
                currentCheckpoint = _ref2[8];
                return _context.abrupt("return", {
                  name: name,
                  owner: owner,
                  address: address,
                  tokenDetails: tokenDetails,
                  version: utils_1.convertVersionToEnum(versionArray),
                  granularity: granularity,
                  totalSupply: totalSupply,
                  currentCheckpoint: currentCheckpoint.toNumber(),
                  treasuryWallet: treasuryWallet
                });

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));
    };

    return _this;
  }

  return SecurityTokenFactory;
}(Factory_1.Factory);

exports.SecurityTokenFactory = SecurityTokenFactory;